<!--LOADING-->
<ng-template [ngIf]="isLoading">
  <app-loading-page class="white-top-theme"></app-loading-page>
</ng-template>
<!--END LOADING-->
<!--VIDEOS-->
<ng-template [ngIf]="!isLoading">
  <section class="video-library">
    <!--FEATURED VIDEOS SECTION-->
    <section
      class="featured-videos"
      *ngIf="featuredVideos && featuredVideos.length > 1; else unavailable">
      <div class="wrapper">
        <!--FEATURED VIDEO MAIN HEADING-->
        <h2 class="text-align-left margin-top-offset">Featured Videos</h2>
        <!--END FEATURED VIDEO MAIN HEADING-->
        <!--FEATURED VIDEO RESULTS-->
        <div
          class="featured-videos-results margin-top-large margin-bottom-large"
          *ngFor="
            let video of featuredVideos | slice : 0 : 1;
            let i = index;
            trackBy: trackByFeaturedVideoId
          ">
          <!--FEATURED VIDEO CONTAINER-->
          <div class="featured-container margin-bottom-large">
            <app-video-container
              [title]="video.title"
              [embedUrl]="video.embed_url"
              (sendClick)="sendGoogleAnalytics('videos', 'click', video.slug)">
            </app-video-container>
          </div>
          <!--END FEATURED VIDEO CONTAINER-->

          <!--FEATURED VIDEO DESCRIPTION-->
          <div class="video-description">
            <!--FEATURED VIDEO TITLE-->
            <h3 *ngIf="video.title">
              <a
                class="gen-neutral-black-link"
                href="javascript:void(0);"
                [routerLink]="['/video', video.slug]"
                (click)="sendGoogleAnalytics('videos', 'click', video.slug)"
                routerLinkActive="active">
                {{ video.title | decodeEntities }}
              </a>
            </h3>
            <!--END FEATURED VIDEO TITLE-->

            <!--FEATURED VIDEO DESCRIPTION-->
            <div class="htmlresponse" *ngIf="video.description">
              <p [innerHTML]="video.description"></p>
            </div>
            <!--END FEATURED VIDEO DESCRIPTION-->
          </div>
          <!--END FEATURED VIDEO DESCRIPTION-->
        </div>
        <!--END FEATURED VIDEO RESULTS-->

        <!--VIDEO SLIDER-->
        <div class="cx-training-videos">
          <div class="cx-training-videos-results" *ngIf="featuredVideos.length > 1">
            <app-video-slider [videoArray]="featuredVideos.slice(1)"></app-video-slider>
          </div>
        </div>
        <!--END VIDEO SLIDER-->
      </div>
    </section>
    <!--END FEATURED VIDEOS SECTION-->

    <!--RECOMMENDED VIDEOS SECTION-->
    <div class="video-library">
      <app-recommended-videos></app-recommended-videos>
    </div>
    <!--END RECOMMENDED VIDEOS SECTION-->
  </section>
</ng-template>
<!--END VIDEOS-->
<ng-template #unavailable>
  <section>
    <p class="wrapper">
      Sorry for the inconvience. We are not able to load content at this time due to technical
      difficulties.
    </p>
  </section>
</ng-template>
